import { render, staticRenderFns } from "./ChildhoodSyndromes.vue?vue&type=template&id=9b26a826&scoped=true"
import script from "./ChildhoodSyndromes.vue?vue&type=script&lang=js"
export * from "./ChildhoodSyndromes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b26a826",
  null
  
)

export default component.exports